module.exports = __webpack_public_path__ + "media/images/iconInfo__okGreen-ebeffd47a9b49aa0ff247535cdc6cfa1.png";